import {
  GetPropsCommonOptions,
  useCombobox,
  UseComboboxGetItemPropsOptions,
  UseComboboxGetMenuPropsOptions,
} from 'downshift';
import { useMemo } from 'react';

import { useComboboxIsOpen } from '../selectors/useComboboxIsOpen';
import { useComboBoxStore } from '../store';
import { IComboboxItem } from '../types';

export const useComboboxControls = (): {
  closeMenu: () => void;
  getMenuProps: (
    options?: UseComboboxGetMenuPropsOptions | undefined,
    otherOptions?: GetPropsCommonOptions | undefined
  ) => any;
  getItemProps: (options: UseComboboxGetItemPropsOptions<IComboboxItem>) => any;
} => {
  const isOpen = useComboboxIsOpen();
  const itemIndex = useComboBoxStore((state) => state.itemIndex);
  const items = useComboBoxStore((state) => state.items);

  // Menu combobox
  const { closeMenu, getMenuProps, getComboboxProps, getInputProps, getItemProps } = useCombobox({
    isOpen,
    highlightedIndex: itemIndex,
    items,
    circularNavigation: true,
  });
  getMenuProps({}, { suppressRefError: true });
  getComboboxProps({}, { suppressRefError: true });
  getInputProps({}, { suppressRefError: true });

  return useMemo(
    () => ({
      closeMenu,
      getMenuProps,
      getItemProps,
    }),
    [closeMenu, getItemProps, getMenuProps]
  );
};
